import { useTheme } from '@mui/material/styles';
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { enviarNteFirmado } from "../../../../redux/actions/nte";
import RequeridoLabel from "../../../commons/labels/RequeridoLabel";
import CircularLoading from "../../../commons/loading/CircularLoading";
import FechaPresentacionLabel from "../../../commons/planillas/FechaPresentacionLabel";
import { StyledNte } from '../../../styled/Prevencion';
import DatosEstablecimientoHeaderLabel from "../commons/labels/DatosEstablecimientoHeaderLabel";
import EstadosNteLabel from "../commons/labels/EstadosNteLabel";
import AdjuntarNteFirmadoContainer from "./AdjuntarNteFirmadoContainer";

const PrePresentacionContainer = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const idRarGuardado = useSelector((state) => state.nte.importacionIdRar);
  const postResponsables = useSelector(
    (state) => state.nte.postNte.responsablesForm
  );
  const obligatoriedadResponsableSH = useSelector(
    (state) => state.nte.obligatoriedadResponsable
  );

  const [nteFirmadoFile, setNteFirmadoFile] = useState(null);
  const [isEnviandoNteFirmado, setIsEnviandoNteFirmado] = useState(false);

  const handleEnviarNteFirmado = () => {
    const responsableDatosCompleto = Boolean(postResponsables?.responsableDeDatos);
    const responsableSHCompleto =
      !Boolean(obligatoriedadResponsableSH.data) ||
      Boolean(postResponsables?.responsableDeSeguridad);

    if (!responsableDatosCompleto || !responsableSHCompleto) {
      toast.error(
        "No es posible presentar el RAR. Debe completar los campos obligatorios: Responsable de los Datos Declarados y Responsable de Seguridad e Higiene"
      );
      return;
    }

    setIsEnviandoNteFirmado(true);

    const aux = {
      idRar: idRarGuardado,
      observaciones: "",
      archivosAsociados: [
        {
          base64: nteFirmadoFile[0]?.value,
          // estamos teniendo errores con enviar el file.base64header
          // que tiene como valor "data:application:pdf;base64"
          // mejor enviar la string "pdf" para la extensión
          extension: "pdf",
        },
      ],
    };

    dispatch(enviarNteFirmado(aux))
      .then((res) => {
        toast.success("Formulario NTE enviado correctamente");
        setIsEnviandoNteFirmado(false);
        navigate("/");
      })
      .catch((err) => {
        toast.error(err);
        setIsEnviandoNteFirmado(false);
      });
  };

  return (
    <>
      <DatosEstablecimientoHeaderLabel />
      <FechaPresentacionLabel />
      <EstadosNteLabel />
      {!isEnviandoNteFirmado ? (
        <AdjuntarNteFirmadoContainer
          file={nteFirmadoFile}
          setFile={setNteFirmadoFile}
          isLoading={isEnviandoNteFirmado}
          handleClickEnviar={handleEnviarNteFirmado}
        />
      ) : (
        <StyledNte.LoadingContainer>
          <CircularLoading
            style={{ color: `${theme.palette.tertiary.main}` }}
          />
          <RequeridoLabel text="Enviando el NTE firmado..." />
        </StyledNte.LoadingContainer>
      )}
    </>
  );
};

export default PrePresentacionContainer;
